// import axios from 'axios';
// import { toast } from 'react-toastify';

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const handleAxiosErrors = (error) => {
//   if (axios.isCancel(error)) {
//     // Handle cancelation
//     throw new Error('Request canceled');
//   }

//   if (error.response) {
//     const { status, data } = error.response;

//     if (status === 404) {
//       // Handle "data not found" error
//       throw new Error('Data not found');
//     } else if (data && data.message) {
//       throw new Error(data.message);
//     } else {
//       throw new Error('Something went wrong');
//     }
//   } else if (error.request) {
//     // The request was made, but no response was received
//     throw new Error('No response received');
//   } else {
//     // Something happened in setting up the request
//     throw new Error('Error setting up the request');
//   }
// };

// const axiosRequest = async (url, method, data) => {
//   try {
//     const response = await axios({ method, url: `${BASE_URL}${url}`, data });
//     return response.data;
//   } catch (error) {
//     toast.error('An error occurred while processing your request');
//     handleAxiosErrors(error);
//   }
// };

// export const get = async (url, params = {}) => {
//   try {
//     const queryParams = new URLSearchParams(params);
//     const apiUrl = `${url}?${queryParams.toString()}`;
//     return await axiosRequest(apiUrl, 'get');
//   } catch (error) {
//     toast.error(error.message || 'An error occurred while fetching data');
//     throw error;
//   }
// };

// export const post = async (url, data) => {
//   try {
//     return await axiosRequest(url, 'post', data);
//   } catch (error) {
//     toast.error(error.message || 'An error occurred while submitting data');
//     throw new Error('Failed to submit data');
//   }
// };

// export const patch = async (url, data) => {
//   try {
//     return await axiosRequest(url, 'patch', data);
//   } catch (error) {
//     toast.error(error.message || 'An error occurred while updating data');
//     throw new Error('Failed to update data');
//   }
// };
// export const put = async (url, data) => {
//   try {
//     return await axiosRequest(url, 'put', data);
//   } catch (error) {
//     toast.error(error.message || 'An error occurred while updating data');
//     throw new Error('Failed to update data');
//   }
// };

// export const del = async (url) => {
//   try {
//     return await axiosRequest(url, 'delete');
//   } catch (error) {
//     toast.error(error.message || 'An error occurred while deleting data');
//     throw new Error('Failed to delete data');
//   }
// };


import axios from 'axios';
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    // Add any additional default headers you need
  }
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    toast.error('An error occurred while processing your request');
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      handleAxiosErrors(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('No response received');
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error('Error setting up the request');
    }
  }
);

const handleAxiosErrors = (response) => {
  const { status, data } = response;
  if (status === 404) {
    throw new Error('Data not found');
  } else if (data && data.message) {
    throw new Error(data.message);
  } else {
    throw new Error(response || 'Something went wrong');
  }
};

const axiosRequest = async (method, url, data, headers) => {
  try {
    const response = await axiosInstance({ method, url, data, headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const get = async (url, params = {}, headers = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const apiUrl = `${url}?${queryParams.toString()}`;
    return await axiosRequest('get', apiUrl, undefined, headers);
  } catch (error) {
    toast.error(error.message || 'An error occurred while fetching data');
    throw error;
  }
};

export const post = async (url, data, headers = {}) => {
  try {
    return await axiosRequest('post', url, data, headers);
  } catch (error) {
    toast.error(error.message || 'An error occurred while submitting data');
    throw error;
  }
};

export const patch = async (url, data, headers = {}) => {
  try {
    return await axiosRequest('patch', url, data, headers);
  } catch (error) {
    toast.error(error.message || 'An error occurred while updating data');
    throw new Error('Failed to update data');
  }
};

export const put = async (url, data, headers = {}) => {
  try {
    return await axiosRequest('put', url, data, headers);
  } catch (error) {
    toast.error(error.message || 'An error occurred while updating data');
    throw new Error('Failed to update data');
  }
};

export const del = async (url, headers = {}) => {
  try {
    return await axiosRequest('delete', url, undefined, headers);
  } catch (error) {
    toast.error(error.message || 'An error occurred while deleting data');
    throw new Error('Failed to delete data');
  }
};

